import { defineComponent, ref, onMounted, onBeforeUnmount, computed, nextTick, watch } from 'vue';
import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';

interface ValueProp {
    name: string,
    description: string,
    icon: string,
    alt: string
}

export default defineComponent({
    props: {
        valueProps: {
            type: Array as () => ValueProp[],
            required: true
        },
    },
    setup: function (props) {
        const propList = ref<ValueProp[]>([
            {
                name: "Protecting Fleets</br>from Scammers",
                description: "Scams in the trucking repair industry are on the rise. Left unverified, scammers will advertise as qualified service providers when the reality is that they broker calls and add huge markups to repair bills.",
                icon: "/img/prod/content/scam-icon.png",
                alt: "Thief icon"
            },
            {
                name: "Saving Fleets</br>Time and Resources",
                description: "Service repair businesses get sold, move, change service offerings, and sometimes close. When fleets waste time by contacting vendors that can't be of service, trucks remain idle. The fleets aren't happy, and neither are we.",
                icon: "/img/prod/content/time-money-icon.png",
                alt: "Clock with a dollar sign"
            },
            {
                name: "Fleets Get Better</br>Repairs for Less Money",
                description: "Unqualified vendors can turn a repair into a nightmare. If vendors get listed for services they aren't competent at or trained in, the result is lower quality repairs and higher costs for fleets. Not acceptable.",
                icon: "/img/prod/content/wrench-icon.png",
                alt: "Wrench and a gear"
            }
        ]);
        return {
            propList
        }
    }
});


